import CustomPopover from "../GeneralComponents/CustomPopover";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { update_favorite_chats_api } from "../../DAL/Messages/Messages";
import { CHAT_MESSAGE_FILTERS } from "../../utils/classRoomUtils";
import { useTranslation } from "react-i18next";

export default function ConversationMenus(props) {
  const { t } = useTranslation();
  const {
    item,
    isUserCard,
    setFilterType,
    get_messages_list,
    handleReadMessage,
    setConversationsList,
  } = props;
  const { userInfo } = useContentSetting();

  const members = Array.isArray(item?.members) ? item.members : [];
  const isUnreadChat = members.find(
    (member) => member?._id === userInfo?._id
  )?.unread_message_count;

  const isMobile = window.screen.width < 992;

  const AddToFavorites = (chat) => {
    if (typeof setConversationsList === "function") {
      setConversationsList((old) =>
        old.map((c) => {
          if (c._id === chat._id) {
            return { ...c, is_favorite: !c.is_favorite };
          }
          return c;
        })
      );
    }
    update_favorite_chats_api(chat._id);
  };

  const handleChangeFilter = (item) => {
    setFilterType(item.value);
    get_messages_list(item.value);
  };

  const getFavoriteTitle = (is_favorite) =>
    is_favorite
      ? t("chatting.conversationMenu.removeFromFavorites")
      : t("chatting.conversationMenu.addToFavorites");

  const menuOptions = () => {
    const options = [
      {
        label: getFavoriteTitle(item.is_favorite),
        icon: "fa6-regular:star",
        handleClick: AddToFavorites,
      },
    ];

    if (isMobile && isUserCard) {
      CHAT_MESSAGE_FILTERS.forEach((filter) => {
        options.push({
          label: t(filter.titleKey),
          icon: filter.icon,
          handleClick: () => handleChangeFilter(filter),
        });
      });
    }
    if (!isUserCard && isUnreadChat) {
      options.push({
        label: t("chatting.conversationMenu.markAsRead"),
        icon: "solar:check-read-outline",
        handleClick: handleReadMessage,
      });
    }
    return options;
  };

  return <CustomPopover menu={menuOptions()} data={item} />;
}
